// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","content":"Modal_content__yBmFf","modalTitle":"Modal_modalTitle__YzazS","modalText":"Modal_modalText__5j2h2","modalButton":"Modal_modalButton__af5s8"};